import PRSSummary from 'ai/components/PRSSummary/PRSSummary';

export default PRSSummary;
